<script lang="ts">
  import { twMerge } from 'tailwind-merge';

  export let avatarUrl: string = '';
  export let title: string;
  export let size: 'small' | 'medium' | 'large' | 'x-large' = 'small';
  export let border: 'none' | 'small' | 'medium' = 'none';

  const getInitials = (title: string) => {
    let titleParts = title && title.length > 0 ? title.split(' ') : [];
    let initials = titleParts.length > 0 ? `${titleParts.at(0)?.at(0)}` : '';

    if (titleParts.length > 1) {
      initials += titleParts.at(-1)?.at(0);
    }
    return initials.toUpperCase();
  };

  let classname = '';
  export { classname as class };

  $: initials = getInitials(title);
  $: hasAvatarUrl = avatarUrl.startsWith('http');
  $: {
    let firstInitial = initials?.at(0) || '';
    if (firstInitial.match(/[a-g]/i)) {
      classname += ' variant1';
    } else if (firstInitial.match(/[h-q]/i)) {
      classname += ' variant2';
    } else if (firstInitial.match(/[r-z]/i)) {
      classname += ' variant3';
    } else {
      classname += ' variant4';
    }
  }
  $: avatarClasses = twMerge(
    `alii-avatar flex items-center justify-center rounded-full border-primary-500 text-[--avatarInitialText]`,
    size,
    size === 'small' && 'h-[24px] w-[24px]',
    size === 'medium' && 'h-[30px] w-[30px]',
    size === 'large' && 'h-[40px] w-[40px]',
    size === 'x-large' && 'h-[50px] w-[50px]',
    hasAvatarUrl ? `bg-cover` : '',
    initials.length > 1 ? 'hasTwoInitials' : '',
    border === 'small' && 'border',
    border === 'medium' && 'border-2',
    classname
  );
</script>

<div class={avatarClasses} style={hasAvatarUrl ? `background-image: url(${avatarUrl});` : ''} {title}>
  {#if !avatarUrl}
    {initials}
  {/if}
</div>

<style lang="postcss">
  @import '$lib/theme/_colours.postcss';
  .alii-avatar {
    &.small.hasTwoInitials {
      @apply text-[10px];
    }
    &.medium.hasTwoInitials {
      @apply text-sm;
    }
    &.large.hasTwoInitials {
      @apply text-sm;
    }
    &.x-large.hasTwoInitials {
      @apply text-sm;
    }
    &.variant1 {
      @apply bg-[--avatarBackground1];
    }
    &.variant2 {
      @apply bg-[--avatarBackground2];
    }

    &.variant3 {
      @apply bg-[--avatarBackground3];
    }
    &.variant4 {
      @apply bg-[--avatarBackground4];
    }
  }
</style>
